// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dislike_wrapper__BpnY8"};